export default "__VITE_ASSET__BH4T5xmE__";